// app/javascript/controllers/bulk_activities_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "activitiesContainer", "activityTemplate", "submitButton", "errorContainer"]

  connect() {
    this.activityCounter = 0

    // Check if there are submitted activities from a previous submission
    if (document.querySelector('[data-submitted-activities]')) {
      const submittedActivities = JSON.parse(document.querySelector('[data-submitted-activities]').dataset.submittedActivities)
      if (submittedActivities && submittedActivities.length > 0) {
        // Add each submitted activity
        submittedActivities.forEach(activity => {
          this.addActivityWithValues(activity)
        })
      } else {
        // If no submitted activities, add a blank one
        this.addActivity()
      }
    } else {
      // No submitted activities, add a blank one
      this.addActivity()
    }

    // Check if there are validation errors passed from the server
    if (this.hasErrorContainerTarget && this.errorContainerTarget.dataset.errors) {
      const errors = JSON.parse(this.errorContainerTarget.dataset.errors)
      this.displayErrors(errors)
    }
  }

  // New method to add an activity with pre-filled values
  addActivityWithValues(activityData) {
    const id = this.activityCounter++
    const template = this.activityTemplateTarget.innerHTML
      .replace(/\${id}/g, id)

    this.activitiesContainerTarget.insertAdjacentHTML('beforeend', template)

    // Initialize select2 for the newly added activity selector
    this.initializeSelect2ForActivity(id)

    // Set the values
    const row = this.element.querySelector(`.activity-row[data-activity-id="${id}"]`)
    if (row) {
      const activitySelect = row.querySelector('.activity-selector')
      const amountInput = row.querySelector('.amount-input')
      const dateInput = row.querySelector('input[type="date"]')

      if (activitySelect && activityData.activity_id) {
        activitySelect.value = activityData.activity_id
        $(activitySelect).trigger('change') // Trigger select2 update
      }

      if (amountInput && activityData.amount) {
        amountInput.value = activityData.amount
      }

      if (dateInput && activityData.completed_at) {
        dateInput.value = activityData.completed_at
      }

      if (activitySelect && activityData.activity_id) {
        const syntheticEvent = {
          currentTarget: {
            dataset: { activityId: id },
            selectedOptions: [activitySelect.selectedOptions[0]]
          }
        }
        this.updateUnits(syntheticEvent)
      }
    }
  }

  addActivity() {
    const id = this.activityCounter++
    const template = this.activityTemplateTarget.innerHTML
      .replace(/\${id}/g, id)

    this.activitiesContainerTarget.insertAdjacentHTML('beforeend', template)

    // Initialize select2 for the newly added activity selector
    this.initializeSelect2ForActivity(id)
  }

  initializeSelect2ForActivity(id) {
    const controller = this
    const selector = $(`.activity-selector[data-activity-id="${id}"]`)

    selector.select2({
      placeholder: 'Select an activity',
      width: '100%',
      containerCssClass: 'form-control select2-container-height',
      dropdownCssClass: 'activity-dropdown'
    })

    selector.on("select2:close", function (evt) {
      var context = $(evt.target);

      $(document).on("keydown.select2", function (e) {
        if (e.which === 9) {
          var highlighted = context
            .data("select2")
            .$dropdown.find(".select2-results__option--highlighted");

          if (highlighted && highlighted.length === 1) {
            $.fn.select2.amd.require(["select2/utils"], function (Utils) {
              var data = Utils.__cache[highlighted.data().select2Id].data;
              var $select2 = context.data('select2');
              $select2.trigger("select", { data: data });
            });
          }
        }
      });

      setTimeout(function () {
        $(document).off("keydown.select2");
      }, 1);
    })

    // Handle the select2:select event to update units and calculate miles
    selector.on('select2:select', function (e) {
      const activityId = $(this).data('activity-id')
      const selectedOption = this.options[this.selectedIndex]
      const units = selectedOption.dataset.units || 'minutes'

      const unitsLabel = controller.element.querySelector(`.units-label[data-activity-id="${activityId}"]`)
      if (unitsLabel) {
        unitsLabel.textContent = units
      }

      // Create a synthetic event to pass to calculateMiles
      const syntheticEvent = { currentTarget: { dataset: { activityId } } }
      controller.calculateMiles(syntheticEvent)

      // Clear error when a value is selected
      const formGroup = $(this).closest('.form-group')[0]
      if (formGroup && formGroup.classList.contains('has-error')) {
        formGroup.classList.remove('has-error')
        const errorMessage = formGroup.querySelector('.help-block')
        if (errorMessage) {
          errorMessage.remove()
        }

        // Reset select2 border
        const select2Container = formGroup.querySelector('.select2-container')
        if (select2Container) {
          select2Container.style.borderColor = ''
        }
      }
    })
  }

  removeActivity(event) {
    const activityId = event.currentTarget.dataset.activityId
    const activityRow = this.element.querySelector(`.activity-row[data-activity-id="${activityId}"]`)

    if (activityRow) {
      // Destroy select2 instance before removing the element
      $(`.activity-selector[data-activity-id="${activityId}"]`).select2('destroy')
      activityRow.remove()
    }

    // Add a new activity if none remain
    if (this.activitiesContainerTarget.children.length === 0) {
      this.addActivity()
    }
  }

  updateUnits(event) {
    // This method is still needed for non-select2 events
    const activityId = event.currentTarget.dataset.activityId
    const selectedOption = event.currentTarget.selectedOptions[0]
    const units = selectedOption.dataset.units || 'minutes'

    const unitsLabel = this.element.querySelector(`.units-label[data-activity-id="${activityId}"]`)
    if (unitsLabel) {
      unitsLabel.textContent = units
    }

    this.calculateMiles(event)

    // Clear error when a value is selected
    const formGroup = event.currentTarget.closest('.form-group')
    if (formGroup && formGroup.classList.contains('has-error')) {
      formGroup.classList.remove('has-error')
      const errorMessage = formGroup.querySelector('.help-block')
      if (errorMessage) {
        errorMessage.remove()
      }
    }
  }

  calculateMiles(event) {
    const activityId = event.currentTarget.dataset.activityId
    const activityRow = this.element.querySelector(`.activity-row[data-activity-id="${activityId}"]`)

    const activitySelect = activityRow.querySelector('.activity-selector')
    const amountInput = activityRow.querySelector('.amount-input')
    const milesDisplay = activityRow.querySelector('.calculated-miles')

    if (activitySelect.value && amountInput.value) {
      const selectedOption = activitySelect.selectedOptions[0]
      const conversionFactor = parseFloat(selectedOption.dataset.conversionFactor) || 0
      const amount = parseFloat(amountInput.value) || 0

      const miles = (amount * conversionFactor).toFixed(2)
      milesDisplay.textContent = miles
    } else {
      milesDisplay.textContent = '0'
    }
  }

  validateForm() {
    let isValid = true
    const errors = {}

    // Get all activity rows
    const activityRows = this.element.querySelectorAll('.activity-row')

    activityRows.forEach((row, index) => {
      const activityId = row.dataset.activityId
      const activitySelect = row.querySelector('.activity-selector')
      const amountInput = row.querySelector('.amount-input')
      const dateInput = row.querySelector('input[type="date"]')

      const rowErrors = {}

      // Validate activity selection
      if (!activitySelect.value) {
        rowErrors.activity = "Activity can't be blank"
        isValid = false
        this.highlightError(activitySelect)
      }

      // Validate amount
      if (!amountInput.value) {
        rowErrors.amount = "Amount can't be blank"
        isValid = false
        this.highlightError(amountInput)
      } else if (parseFloat(amountInput.value) <= 0) {
        rowErrors.amount = "Amount must be greater than 0"
        isValid = false
        this.highlightError(amountInput)
      }

      // Validate date
      if (!dateInput.value) {
        rowErrors.date = "Date can't be blank"
        isValid = false
        this.highlightError(dateInput)
      }

      if (Object.keys(rowErrors).length > 0) {
        errors[index] = rowErrors
      }
    })

    if (!isValid) {
      this.displayErrors(errors)
    }

    return isValid
  }

  displayErrors(errors) {
    // Clear existing error messages
    this.element.querySelectorAll('.help-block').forEach(el => el.remove())

    // Remove existing has-error classes
    this.element.querySelectorAll('.has-error').forEach(el => {
      el.classList.remove('has-error')
    })

    // Reset all select2 borders
    this.element.querySelectorAll('.select2-container').forEach(el => {
      el.style.borderColor = ''
    })

    // Display new error messages
    Object.entries(errors).forEach(([index, rowErrors]) => {
      const row = this.element.querySelectorAll('.activity-row')[parseInt(index)]
      if (row) {
        Object.entries(rowErrors).forEach(([field, message]) => {
          let formGroup

          switch (field) {
            case 'activity':
            case 'activity_id':
              formGroup = row.querySelector('.activity-form-group')
              // Special handling for select2
              if (formGroup) {
                const select2Container = formGroup.querySelector('.select2-container')
                if (select2Container) {
                  select2Container.style.borderColor = '#e74c3c'
                }
              }
              break
            case 'amount':
              formGroup = row.querySelector('.amount-form-group')
              break
            case 'date':
            case 'completed_at':
              formGroup = row.querySelector('.date-form-group')
              break
          }

          if (formGroup) {
            formGroup.classList.add('has-error')
            const errorSpan = document.createElement('span')
            errorSpan.className = 'help-block'
            errorSpan.textContent = message
            formGroup.appendChild(errorSpan)
          }
        })
      }
    })
  }

  highlightError(element) {
    // Find the parent form-group
    let formGroup = element.closest('.form-group')
    if (!formGroup) {
      // If not directly in a form-group, try to find the custom form group
      if (element.classList.contains('activity-selector')) {
        formGroup = element.closest('.activity-form-group')
      } else if (element.classList.contains('amount-input')) {
        formGroup = element.closest('.amount-form-group')
      } else {
        formGroup = element.closest('.date-form-group')
      }
    }

    if (formGroup) {
      formGroup.classList.add('has-error')

      // Special handling for select2
      if (element.classList.contains('activity-selector')) {
        const select2Container = formGroup.querySelector('.select2-container')
        if (select2Container) {
          select2Container.style.borderColor = '#e74c3c'
        }
      }

      // Add event listener to clear error on input
      if (!element.classList.contains('activity-selector')) {
        // For regular inputs
        element.addEventListener('input', () => {
          formGroup.classList.remove('has-error')
          const errorMessage = formGroup.querySelector('.help-block')
          if (errorMessage) {
            errorMessage.remove()
          }
        }, { once: true })
      }
      // For select2, the event is handled in the select2:select event
    }
  }

  submitForm(event) {
    if (!this.validateForm()) {
      event.preventDefault()
    }
  }

  cloneActivity(event) {
    const activityId = event.currentTarget.dataset.activityId
    const activityRow = this.element.querySelector(`.activity-row[data-activity-id="${activityId}"]`)

    if (activityRow) {
      // Get values from the current row
      const activitySelect = activityRow.querySelector('.activity-selector')
      const amountInput = activityRow.querySelector('.amount-input')
      const dateInput = activityRow.querySelector('input[type="date"]')

      // Create a new activity with these values
      this.addActivityWithValues({
        activity_id: activitySelect.value,
        amount: amountInput.value,
        completed_at: dateInput.value
      })
    }
  }
}
